/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paymentMethodContributionDataTypeSchema = z.enum(['wallet', 'invoice', 'stripe'])

export type PaymentMethodContributionDataTypeSchema = z.infer<typeof paymentMethodContributionDataTypeSchema>
